"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, PropSync, Vue, Ref } from "vue-property-decorator";
import UiGrid, { GridController } from "@/components/grid/UiGrid.vue";
import _ from "lodash";
import { APIDataSource } from "@/components/grid/data-source";
import API from "@ym-framework/api-utils";
import Question from "@/components/Question.vue";
import AdvancedSearchForm from "./search/AdvancedSearchForm.vue";
import { UiFormController } from "@/components/form/UiForm.vue";
import DateFormat from "@/framework/timeformatter";
import { UiConfirm } from "@/service/ConfirmBox/confirm";
import BatchOperate from "./batchComponents/BatchOperate.vue";
const _gridController = new GridController(
  new APIDataSource("api://base.auth/api/v8/team/members/audit")
);
class FormController extends UiFormController {
  constructor() {
    super(...arguments);
    this.mumber_no = null;
    this.name = null;
    this.search_date = [];
    this.phone = null;
    this.states = null;
  }
}
let mumberAudit = class extends Vue {
  constructor() {
    super(...arguments);
    this.searchItem = null;
    this.searchData = "";
    this.searchStr_datas = {};
    this.searchStatus_datas = {};
    this.searchDate_datas = {};
    this.selectDatas = [];
    this.formatter = DateFormat;
    this.gridController = _gridController;
    this.formController = new FormController();
    this.pickerOptions = {
      shortcuts: [
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.today"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(new Date(start.toLocaleDateString()).getTime());
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.lastday"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(new Date(start.toLocaleDateString()).getTime() - 3600 * 1e3 * 24);
            start.setHours(0, 0, 0, 0);
            end.setTime(new Date(end.toLocaleDateString()).getTime());
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.thisweek"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - (start.getDay() - 1) * 3600 * 1e3 * 24);
            start.setHours(0, 0, 0, 0);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.lastsevenday"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1e3 * 24 * 7);
            start.setHours(0, 0, 0, 0);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.lastweek"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - (start.getDay() + 6) * 3600 * 1e3 * 24);
            start.setHours(0, 0, 0, 0);
            end.setTime(end.getTime() + (0 - end.getDay()) * 3600 * 1e3 * 24);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.thismonth"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.setDate(1));
            start.setHours(0, 0, 0, 0);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.lastthirtydays"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1e3 * 24 * 30);
            start.setHours(0, 0, 0, 0);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.lastmonth"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(new Date(start.setMonth(start.getMonth() - 1)).setDate(1));
            start.setHours(0, 0, 0, 0);
            end.setTime(end.setDate(1));
            picker.$emit("pick", [start, end]);
          }
        }
      ],
      disabledDate(time) {
        return time.getTime() > new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1e3 - 1) || time.getTime() < new Date(new Date().setMonth(new Date().getMonth() - 6));
      }
    };
    this.batchOperates = new Map(
      function* () {
        yield [
          "batch-remove-team",
          require("@/views/managements/teammanager/components/batchComponents/BatchRemoveTeam.vue").default
        ];
        yield [
          "batch-pass-team",
          require("@/views/managements/teammanager/components/batchComponents/BatchPassTeam.vue").default
        ];
        yield [
          "batch-refuse-team",
          require("@/views/managements/teammanager/components/batchComponents/BatchRefuseTeam.vue").default
        ];
      }()
    );
    this.expiryDate = [
      // new Date().setMonth(new Date().getMonth() - 3),
      new Date(new Date().getTime() - 3600 * 1e3 * 24 * 7),
      new Date()
    ];
    this.autid_options = [
      {
        value: null,
        label: this.$t("team_management.team_validator.all")
      },
      {
        value: "pass",
        label: this.$t("team_management.team_validator.pass")
      },
      {
        value: "wait",
        label: this.$t("team_management.team_validator.wait")
      },
      {
        value: "refuse",
        label: this.$t("team_management.team_validator.refuse")
      }
    ];
    this.searchParams = {
      search: {},
      select: null
    };
    this.searchDate = _.debounce((searchDate) => __async(this, null, function* () {
      if (searchDate !== null && searchDate !== []) {
        let _start_time = Date.parse(searchDate[0]);
        let _end_time = Date.parse(searchDate[1]);
        this.searchDate_datas = {
          start_time: _start_time,
          end_time: _end_time
        };
        this.searchAllData();
        return;
      }
      if (searchDate === null || searchDate === []) {
        this.searchDate_datas = null;
        this.searchAllData();
      }
    }), 500);
    this.searchSelect = _.debounce((item) => __async(this, null, function* () {
      if (item !== null) {
        this.searchStatus_datas = {
          type: item
        };
        this.searchAllData();
        return;
      }
      if (item === null) {
        this.searchStatus_datas = null;
        this.searchAllData();
      }
    }), 500);
    this.searchAllData = _.debounce(() => {
      this.gridController.query.current = 1;
      this.searchParams = {
        search: {},
        select: null
      };
      if (this.searchStatus_datas !== null) {
        this.searchParams.search = this.searchStatus_datas;
        if (this.searchDate_datas !== null) {
          let obj = __spreadValues(__spreadValues({}, this.searchDate_datas), this.searchStatus_datas);
          this.searchParams.search = obj;
        }
      }
      if (this.searchStatus_datas === null || this.searchStatus_datas === {}) {
        this.searchParams = {
          search: {},
          select: null
        };
        if (this.searchDate_datas !== null) {
          this.searchParams.search = this.searchDate_datas;
        }
      }
      this.gridController.query.params = this.searchParams;
      this.gridController.search();
    }, 500);
    this.searchName = _.debounce((data) => __async(this, null, function* () {
      console.log(data);
    }), 500);
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
      yield this.searchDate(this.expiryDate);
    });
  }
  clearBatch() {
    this.selectDatas = [];
    this._grid_table.clearSelection();
  }
  selectItems(items) {
    this.selectDatas = items;
  }
  gridSort(data) {
    return __async(this, null, function* () {
      yield this.gridController.search();
    });
  }
  searchQuery(query) {
    return __async(this, null, function* () {
      this.searchParams.search = query.params;
      this.gridController.query.params = this.searchParams;
      this.gridController.query.current = 1;
      yield this.gridController.search();
    });
  }
  showRightDrawer() {
    return __async(this, null, function* () {
      yield this.clearSearchQuery();
      const _advancedSearchForm = AdvancedSearchForm.create(this.formController);
      _advancedSearchForm.$on("search", this.searchQuery);
      _advancedSearchForm.show();
    });
  }
  clearSearchQuery() {
    return __async(this, null, function* () {
      if (this.searchDate !== null && this.searchDate.length > 0 || this.searchItem !== null) {
        this.expiryDate = [];
        this.searchItem = null;
        this.formController = new FormController();
        this.gridController.query.params = {
          search: {},
          select: null
        };
        yield this.gridController.search();
      }
    });
  }
  refresh() {
    return __async(this, null, function* () {
      this.gridController.query.params = this.searchParams;
      yield this.gridController.search();
    });
  }
  removeMember(data) {
    return __async(this, null, function* () {
      try {
        let arr = [];
        arr.push(data.member_guid);
        yield UiConfirm.confirm(
          this.$t("memberaudit.remove_team_member_reminder"),
          this.$t("team_management.remove_team_content", {
            name: data.name
          }),
          {
            confirmButtonText: this.$t(
              "team_management.remove_team_confirm"
            ),
            cancelButtonText: this.$t(
              "team_management.remove_team_cancel"
            )
          }
        );
        yield API.delete(`api://base.auth/api/v1/team/members/audit`, {
          data: {
            member_guids: arr
          }
        });
        yield this.refresh();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  passMember(data) {
    return __async(this, null, function* () {
      try {
        let arr = [];
        arr.push(data.member_guid);
        yield API.post(`api://base.auth/api/v1/team/members/audit`, {
          member_guids: arr,
          status: "pass"
        });
        yield this.refresh();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  refuseMember(data) {
    return __async(this, null, function* () {
      try {
        let arr = [];
        arr.push(data.member_guid);
        yield API.post(`api://base.auth/api/v1/team/members/audit`, {
          member_guids: arr,
          status: "refuse"
        });
        yield this.refresh();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
};
__decorateClass([
  Ref("grid-table")
], mumberAudit.prototype, "_grid_table", 2);
__decorateClass([
  PropSync("refreshKey", { type: String })
], mumberAudit.prototype, "random_key", 2);
mumberAudit = __decorateClass([
  Component({
    components: {
      UiGrid,
      Question,
      BatchOperate
    }
  })
], mumberAudit);
export {
  mumberAudit as default
};
